import { getEquipmentObservations } from '../../api/api';
import { Equipment } from '../equipments';
import { AssetObservationsState, createAssetObservationsSlice } from './abstract/asset';

const equipmentObservationsSlice = createAssetObservationsSlice<Equipment>('equipments', {
  fetchObservations: getEquipmentObservations,
});

const { fetchAssetObservations } = equipmentObservationsSlice.actions;
export { fetchAssetObservations as fetchEquipmentObservations };
export const { selectState: selectEquipmentObservationsState } = equipmentObservationsSlice.getSelectors(
  (state: { observations: { equipments: AssetObservationsState<Equipment> } }) => state.observations.equipments,
);

export default equipmentObservationsSlice.reducer;
